<template>
  <div class="modal fade" ref="modal" aria-label="Modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog gf gf-small modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fa fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="d-flex align-items-center mb-4">
            <i class="fa fa-paper-plane mr-3 brand-primary-gradient"></i>
            <h5 class="header-case mb-0">{{ __('SHARE REVIEW') }}</h5>
          </div>

          <div class="alert alert-success" v-if="message != ''">
            {{ message }}
          </div>
          <div class="alert alert-danger" v-if="errorMessage != ''">
            {{ errorMessage }}
          </div>

          <div class="form-group">
            <label for="emailInput"
              ><strong>{{ __('Email(s)') }}</strong></label
            >
            <multi-text-input :cols="12" v-model="emails" />
          </div>

          <div class="form-group">
            <label for="messageInput"
              ><strong>{{ __('Message') }}</strong></label
            >
            <textarea class="form-control" v-model="inputMessage" rows="3"></textarea>
          </div>

          <div class="text-right pt-4">
            <button
              type="button"
              @click.prevent="share"
              class="btn btn-primary btn-lg"
              :disabled="sending || emails.length == 0 || emails[0].length < 5"
            >
              <i class="fa fa-paper-plane"></i>
              Send<span v-if="sending">ing...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiTextInput from '../generic/MultiTextInput.vue';
export default {
  components: {
    MultiTextInput,
  },
  props: {
    review: Object,
  },
  data() {
    return {
      emails: [],
      sending: false,
      message: '',
      errorMessage: '',
      inputMessage: '',
    };
  },
  mounted() {
    const that = this;
    this.$nextTick(function () {
      $(this.$refs.modal).modal('toggle');
      $(this.$refs.modal).on('hidden.bs.modal', function (e) {
        that.$emit('close', e);
      });
    });
  },
  methods: {
    share() {
      if (this.emails.length == 0 || !this.emails[0].includes('@')) {
        this.errorMessage = 'No valid emails have been set';
        return;
      }
      const postData = {
        emails: this.emails,
        message: this.inputMessage,
      };
      this.sending = true;
      axios
        .post(`/api/reviews/share/${Spark.state.currentTeam.id}/${this.review.id}`, postData)
        .then((response) => {
          this.sending = false;
          this.message = `Successfully shared this review with ${this.emails.join(', ')}`;
          this.errorMessage = '';
          this.emails = [];
          this.inputMessage = '';
        })
        .catch((error) => {
          this.errorMessage = 'Something went wrong';
          this.sending = false;
        });
    },
  },
};
</script>
